import * as Yup from "yup";
import dayjs from "dayjs";

const nowDate = dayjs();
const minDate = nowDate
      .month(nowDate.month() - 1)
      .date(1)
      .hour(0)
      .minute(0)
      .second(0);

export const advancedValidationSchema = Yup.object({
    // companyName: Yup
    //     .string()
    //     .required("Required"),
    // documentNo: Yup
    //     .string()
    //     .required("Required"),
})

export const advancedInitialValues = {
    documentNo: "",
}

export const validationSchema = Yup.object({
    locationIds: Yup
          .array()
          .required("Required"),
    toLocationIds: Yup
          .array(),
    createDateFrom: Yup
          .date()
          .nullable()
          // .min(minDate, `Date must be after ${minDate.format('YYYY-MM-DD').toString()}`)
          .max(
                Yup.ref('createDateTo'), // Reference another field
                'Create Date From must be before Create Date To'
          ),
    createDateTo: Yup
          .date()
          .nullable()
          .min(
                Yup.ref('createDateFrom'), // Reference another field
                'Create Date To must be after Create Date From'
          ),
    dateFrom: Yup
          .date()
          .required('Required')
          // .min(minDate, `Date must be after ${minDate.format('YYYY-MM-DD').toString()}`)
          .max(
                Yup.ref('dateTo'), // Reference another field
                'Document Date From must be before Document Date To'
          ),
    dateTo: Yup
          .date()
          .required('Required')
          .min(minDate, `Date must be after ${minDate.format('YYYY-MM-DD').toString()}`)
          .max(
                Yup.ref('dateTo'), // Reference another field
                'Document Date From must be before Document Date To'
          ),
})

export const initialValues = {
    locationIds: [],
    toLocationIds: [],
    createDateFrom: "",
    createDateTo: "",
    dateFrom: "",
    dateTo: "",

    itemName: "",
    itemCode: "",
}